import { defaultTypography } from '@backstage/theme';

// Sem tipo explícito (BackstageTypography) de propósito: o tipo público não
// declara `letterSpacing` em h1-h3 (só fontFamily/fontSize/fontWeight/
// marginBottom), mas o MUI aceita a propriedade em runtime. Anotar o tipo
// aqui forçaria excess-property-check e quebraria o build; passado como
// variável (não como literal inline) pro createUnifiedTheme, o TS só checa
// atribuição estrutural — sem erro, sem `as any`.
export const typography = {
  ...defaultTypography,
  fontFamily: '"Work Sans", system-ui, sans-serif',
  h1: { ...defaultTypography.h1, fontWeight: 700, letterSpacing: '-0.02em' },
  h2: { ...defaultTypography.h2, fontWeight: 700, letterSpacing: '-0.02em' },
  h3: { ...defaultTypography.h3, fontWeight: 600, letterSpacing: '-0.015em' },
  h4: { ...defaultTypography.h4, fontWeight: 600 },
  h5: { ...defaultTypography.h5, fontWeight: 600 },
  h6: { ...defaultTypography.h6, fontWeight: 600 },
};
